import personalInfoFields from 'modules/Taps/components/PersonalInfoGP3/fieldsConfig';
import { getRequiredFn, getValidateMaxDateFn, isValidDate } from 'utils/reduxForm/validations';
import moment from 'utils/moment';

export const NOTIFICATION_NUMBER = '1112015';
export const INN_RESPONSE_NUMBER = '1122022';
export const FORM_NAME = 'InnCertificateRequestForm';
export const DISABLED_FORM_NAME = 'InnCertificateRequestFormDisabled';
export const WITHOUT_CITIZENSHIP_CODE = '999';
export const RUSCODE = '643';
export const RF_CITIZENSHIP_DOCS = ['03', '21', '22'];
export const FOREIGN_CITIZENSHIP_DOCS = ['10', '23'];
export const genderOptions = [
  {
    value: 1,
    label: 'Мужской',
  },
  {
    value: 2,
    label: 'Женский',
  },
];
export const RF_CITIZENSHIP = 1;
export const FOREIGN_CITIZENSHIP = 2;
export const WITHOUT_CITIZENSHIP = 3;
export const citizenOptions = [
  {
    value: RF_CITIZENSHIP,
    label: 'Гражданин Российской Федерации',
  },
  {
    value: FOREIGN_CITIZENSHIP,
    label: 'Иностранный гражданин',
  },
  {
    value: WITHOUT_CITIZENSHIP,
    label: 'Лицо без гражданства',
  },
];
export const normalizedCitizenship = {
  [RF_CITIZENSHIP]: 1,
  [FOREIGN_CITIZENSHIP]: 1,
  [WITHOUT_CITIZENSHIP]: 2,
};
export const RIGHT_TO_RESIDE_DOC_OPTIONS = ['12', '15'];
export const REGISTRATION_DOC_OPTIONS = ['11', '12', '13', '15', '19', '61', '63', '91'];
export const RESIDENCE_PLACE = 1;
export const STAY_PLACE = 2;
export const WITHOUT_STAY_PLACE = 3;
export const residenceTypeOptions = [
  {
    value: RESIDENCE_PLACE,
    label: 'Место жительства',
  },
  {
    value: STAY_PLACE,
    label: 'Место пребывания (при отсутствии места жительства)',
  },
];

const personalPhone = {
  ...personalInfoFields.phone,
  isRequired: false,
  label: 'Телефон',
  validate: null,
};

const isRequired = getRequiredFn();

const address = {
  ...personalInfoFields.address,
  isRequired: false,
  validate: () => null,
};

const registrationDate = {
  ...personalInfoFields.registrationDate,
  isRequired: false,
  validate: [isValidDate, getValidateMaxDateFn(moment().endOf('day'))],
};
export const personalDataFields = [
  { ...personalInfoFields.inn, isRequired: true, validate: isRequired },
  personalInfoFields.lastName,
  personalInfoFields.firstName,
  personalInfoFields.middleName,
  { ...personalInfoFields.dateOfBirth, isRequired: true, validate: isRequired },
  { ...personalInfoFields.placeOfBirth, isRequired: true, validate: isRequired },
  personalInfoFields.documentTypes,
  personalInfoFields.documentNumber,
  personalInfoFields.documentDate,
  personalInfoFields.issuedBy,
  address,
  registrationDate,
  personalInfoFields.departmentCode,
  personalPhone,
];
export const fieldsNames = {
  taxAuthority: {
    name: 'taxAuthority',
  },
  residenceDocType: {
    name: 'residenceDocType',
  },
  residenceDocNumber: {
    name: 'residenceDocNumber',
  },
  residenceDocDate: {
    name: 'residenceDocDate',
  },
  residenceDocIssuedBy: {
    name: 'residenceDocIssuedBy',
  },
  residenceDocEndDate: {
    name: 'residenceDocEndDate',
  },
  gender: {
    name: 'gender',
  },
  birthActNumber: {
    name: 'birthActNumber',
  },
  citizenship: {
    name: 'citizenship',
  },
  countryCode: {
    name: 'countryCode',
  },
  addressAttribute: {
    name: 'addressAttribute',
  },
  expiredDate: {
    name: 'expiredDate',
  },
  rightToResideSection: {
    name: 'rightToResideSection',
  },
  registrationSection: {
    name: 'registrationSection',
  },
  registrationDate: {
    name: 'registrationDate',
  },
};
